export default __webpack_public_path__ + "static/media/gamecord.aaf6677e.png";